import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from './api.service';
import { ResetPassword } from '../models';

@Injectable({ providedIn: 'root' })
export class UserService {
  url = '/users';

  constructor(private apiService: ApiService) {}

  isUserNameExists(username: string, userId: string): Observable<boolean> {
    return this.apiService
      .get(`${this.url}/username-exists/${username}/${userId}`)
      .pipe(map(data => data.data));
  }

  isEmailExists(email: string, userId: string): Observable<boolean> {
    return this.apiService
      .get(`${this.url}/email-exists/${email}/${userId}`)
      .pipe(map(data => data.data));
  }

  resetPassword(model: ResetPassword): Observable<void> {
    return this.apiService.post(`${this.url}/reset-password`, model);
  }
}
